import React from 'react';
import {Container, Typography} from '@mui/material';
import {SeverityColor} from '../../constants/securspace-constants';
import {styled} from "@mui/material/styles";

const ManagedLocationChipTypography = styled(Typography)(() => ({
  color: 'white',
  textTransform: 'uppercase',
  fontSize: '.7143rem',
  fontFamily: 'Inter',
  fontStyle: 'normal',
  fontWeight: 500,
  lineHeight: '1rem',
}));

interface ManagedLocationChipContainerProps {
  severity: SeverityColor;
  chipColor?: string;
}

const ManagedLocationChipContainer = styled(Container, {
  shouldForwardProp: propName => propName !== 'severity' && propName !== 'chipColor'
})<ManagedLocationChipContainerProps>(({theme, severity, chipColor}) => ({
  '&&': { // trick to force these styles to take precedence to match previous styling
    background: chipColor ?? theme.palette[severity].main,
    borderRadius: '0.2857em',
    padding: '0.2857em 0.5714em',
    width: 'fit-content'
  }
}));

interface LocationManagedLocationChipProps {
  label: string;
  severity?: SeverityColor;
  /** Raw color override that takes priority over the severity-derived theme color. */
  chipColor?: string;
}

const LocationManagedLocationChip = (props: LocationManagedLocationChipProps) => {
  const {label, severity = 'success', chipColor} = props;

  return <ManagedLocationChipContainer severity={severity} chipColor={chipColor}>
    <ManagedLocationChipTypography>{label}</ManagedLocationChipTypography>
  </ManagedLocationChipContainer>
}

export default LocationManagedLocationChip;
